var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "results-footer" } }, [
    _c("div", { staticClass: "results-footer-content" }, [
      _c("div", { staticClass: "search-onboarding" }, [
        _c("div", {
          staticClass: "typography results-footer-typography",
          domProps: { innerHTML: _vm._s(_vm.t("app-results-html")) },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dont-see-your-program" }, [
        _c("div", {
          staticClass: "typography results-footer-typography",
          domProps: { innerHTML: _vm._s(_vm.t("app-dont-see-your-program")) },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }